<template>
    <div class="finance-disclaimer text-body2 mt-4">
        <p  v-if="content?.FINANCE_DISCLAIMER?.APR_TEXT && content.FINANCE_DISCLAIMER.APR_TEXT.trim()"
            v-html="content.FINANCE_DISCLAIMER.APR_TEXT">
           
        </p>
        <p v-if="props.showCommission && progressStore.formType !== 'dealerGetMyQuote'" v-html="`${content.FINANCE_DISCLAIMER.FINANCE_247_STYLED} ${content.FINANCE_DISCLAIMER.COMMISSION_TEXT}`">
        </p>

        <p v-if="showCreditCheckDisclaimer"><span class="text-body3">*Car Finance 247</span> runs a soft credit check for your quote (no impact on your score). If you proceed, a hard credit check is required which may affect your score.</p>
    </div>
</template>

<script setup lang="ts">
// import * as content from '@/constants/content';
import { useConfigStore } from '@/stores/modules/configStore';
import { useProgressStore } from '@/stores/modules/progressStore';
import { RequestHelper } from '@/helpers';
import { ref, onMounted, computed } from 'vue';

const content = useConfigStore().affiliateConfig.contents;
const progressStore = useProgressStore();
const showCreditCheckDisclaimer = computed(() => {
    const option = RequestHelper.getQueryVariable('option');
    const isFinanceOption = option === 'finance' || option === 'refinance';
    const isDealerGetMyQuote = progressStore.formType === 'dealerGetMyQuote';
    
    return isFinanceOption || isDealerGetMyQuote;
});

const props = defineProps({
    showCommission: {
        type: Boolean,
        default: true
    }
});
</script> 